export enum ExternalPaymentMethod {
    CreditCard = "Kreditkarte", 
    Maestro = "Maestro",  
    PostFinance = "PostFinance",  
    Twint = "Twint",
}
export type NonExternalPaymentMethod = "Rechnung" | "Guthaben"
export type PaymentMethod = ExternalPaymentMethod | NonExternalPaymentMethod;